import React            from 'react';

class Container extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let p = this.props;
        return(
            <div className={ `marketkit-textfield${ p.className ? ' ' + p.className : '' }` }>
                { p.children }
            </div>
        )
    }
}

export default Container;